import React from 'react';
import ChefSection from './ChefSection';
import CommunitySection from './CommunitySection';
import TestimonialGallery from './TestimonialGallery';
import PressSection from './PressSection';

// Example images (feel free to update URLs)
const OCTOPUS = 'https://santaplaya-bucket.s3.amazonaws.com/blue_octopus.webp';
const BUBBLES = 'https://santaplaya-bucket.s3.amazonaws.com/bubbles_blue.webp';
const TILAPIA = 'https://santaplaya-bucket.s3.amazonaws.com/blueTalapia.webp';

const SECTION_ONE_TITLE = `SANTA PLAYA MARISCOS
IS THE LATEST CULINARY
CREATION FROM CHEF
JONATHAN ‘YONA’ ESTRADA.`;

const SECTION_ONE_BODY = `Growing up on Santa Barbara’s Westside, Yona’s passion
for food began in a friend’s backyard in 2019. From
humble beginnings as a dishwasher and auto mechanic,
he turned family recipes into a sensation with Yona Redz.
Now, he’s bringing the vibrant seafood flavors of Baja
California to State Street, offering the best Mexican
seafood in Santa Barbara.`;

const SECTION_TWO_TITLE = `OUR MISSION IS TO BRING
THE VIBRANT FLAVORS OF
BAJA CALIFORNIA TO
SANTA BARBARA`;

const SECTION_TWO_BODY = `We are committed to serving fresh, high-quality Mexican seafood
in a casual yet refined atmosphere where every guest feels like
part of our family.`;

const AboutUsPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center w-full bg-white mt-[15vh] md:mt-0">
      {/* SECTION ONE: Text Left, Images Right */}
      <section className="flex flex-col md:flex-row items-center w-full py-12 pl-4 sm:px-8 md:pl-12">
        {/* TEXT (Left) */}
        <div className="md:w-2/3 flex flex-col md:pr-8">
          <h2 className="text-wrap font-charles text-maroon text-5xl md:text-6xl xl:text-7xl mb-6">
            {SECTION_ONE_TITLE}
          </h2>
          <p className="text-wrap font-prosto text-sea text-base md:text-lg xl:text-xl leading-relaxed">
            {SECTION_ONE_BODY}
          </p>
        </div>

        {/* IMAGES (Right) */}
        <div className="mt-8 md:mt-0 md:w-1/3 relative flex justify-center">
          {/* Octopus */}
          <img
            src={OCTOPUS}
            alt="Octopus"
            className="w-[60%] max-w-sm object-cover relative z-10"
          />
          {/* Bubbles */}
          <img
            src={BUBBLES}
            alt="Bubbles"
            className="absolute bottom-0 right-0 w-[50%] max-w-[150px] opacity-80"
          />
        </div>
      </section>

      {/* SECTION TWO: 
          Row 1: Image left, Title right
          Row 2: Body text below
      */}
      <section className="flex flex-col w-full py-12 px-4 sm:px-8 md:px-12">
        {/* ROW 1: Image on left, Title on right */}
        <div className="flex flex-col md:flex-row items-center">
          {/* IMAGES (Left) */}
          <div className="md:w-1/3 flex justify-center relative">
            {/* Tilapia */}
            <img
              src={TILAPIA}
              alt="Tilapia"
              className="w-[60%] max-w-sm object-cover relative z-10"
            />
            {/* Bubbles */}
            <img
              src={BUBBLES}
              alt="Bubbles"
              className="absolute top-0 left-0 w-[50%] max-w-[120px] opacity-80"
            />
          </div>

          {/* TITLE (Right) */}
          <div className="mt-8 md:mt-0 md:w-2/3 md:pl-8 flex flex-col">
            <h2 className="text-wrap font-charles text-maroon text-5xl md:text-6xl xl:text-7xl mb-6">
              {SECTION_TWO_TITLE}
            </h2>
          </div>
        </div>

        {/* ROW 2: Body text below */}
        <div className="mt-6 flex justify-center">
          <p
            className="
      font-prosto 
      text-sea 
      text-base 
      md:text-lg 
      xl:text-xl 
      leading-relaxed 
      text-center 
      max-w-5xl
    "
          >
            {SECTION_TWO_BODY}
          </p>
        </div>
      </section>
      <ChefSection />
      <CommunitySection />
      <TestimonialGallery />
      <PressSection />
    </div>
  );
};

export default AboutUsPage;
